import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';
import PrimaryButton from '@components/PrimaryButton';
import ArrowLeft from '@components/Icons/ArrowLeft';
import { useServiceItemsContext } from '@hooks';
import { serviceStatusList } from '@constants';
import { calculateMinutesPast, defineIsMinutesPast } from '@utils';
import SICardComponent from '../component/SICardComponent';
import {
  useStylesSecondaryButton,
  useStylesSecondaryIconButton,
} from './styles';

const SICardContainer = ({
  orderDataMap,
  expandedMap,
  isNeitherCardExpandedYet,
  handleAccordionChange,
}) => {
  const { t } = useTranslation('pointOfService');
  const classesSecondaryButton = useStylesSecondaryButton();
  const classesSecondaryIconButton = useStylesSecondaryIconButton();

  const { id, status, created, serviceItemsIds } = orderDataMap;
  const [isOpenModal, setOpenModal] = useState(false);

  const {
    webSocketInstance,
    updateServiceItemsGrouped,
  } = useServiceItemsContext();

  const formServiceItemsUpdate = (serviceItemsList, status) => {
    return serviceItemsList.reduce((acc, item) => {
      acc.push({ id: item, status });
      return acc;
    }, []);
  };

  const formWebSocketMessage = serviceElems => ({
    action: 'updateServiceItems',
    serviceItems: serviceElems,
  });

  const changeOrderGroupStatus = (serviceItemsList, statusOrderGroup) => () => {
    const updatedServiceItemsList = formServiceItemsUpdate(
      serviceItemsList,
      statusOrderGroup,
    );

    const webSocketMessage = formWebSocketMessage(updatedServiceItemsList);
    updateServiceItemsGrouped(webSocketInstance, webSocketMessage);
  };

  const handleModalShow = isOpen => () => setOpenModal(isOpen);

  const minutesPast = calculateMinutesPast(created);

  const isMinutesPast = defineIsMinutesPast({
    minutesPast,
    statusOrder: status,
    comparingMinutesCount: 10,
  });

  const defineButtonComponent = status => {
    const foundServiceStatusCurrentIdx = serviceStatusList.indexOf(status);

    switch (status) {
      case 'preparing':
      case 'ready':
      case 'out': {
        return (
          <Box display="flex">
            <PrimaryButton
              classesButton={classesSecondaryIconButton}
              text={<ArrowLeft />}
              handleClick={handleModalShow(true)}
            />
            <PrimaryButton
              text={t(
                `orderStatusList.${
                  serviceStatusList[foundServiceStatusCurrentIdx + 1]
                }`,
              )}
              handleClick={changeOrderGroupStatus(
                serviceItemsIds,
                serviceStatusList[foundServiceStatusCurrentIdx + 1],
              )}
            />
          </Box>
        );
      }
      case 'delivered': {
        return (
          <PrimaryButton
            text={t('buttons.sendBackButton')}
            startIcon={<ArrowLeft />}
            classesButton={classesSecondaryButton}
            handleClick={handleModalShow(true)}
          />
        );
      }
      case 'cancelled': {
        return null;
      }
      default: {
        return (
          <PrimaryButton
            text={t('orderStatusList.preparing')}
            handleClick={changeOrderGroupStatus(serviceItemsIds, 'preparing')}
          />
        );
      }
    }
  };

  const Button = defineButtonComponent(status);
  const minutesPastValue = minutesPast > 60 ? '> 1 hr' : `${minutesPast} min`;

  const supplementedOrderDataMap = {
    ...orderDataMap,
    isMinutesPast,
    minutesPastValue,
  };

  return (
    <>
      {supplementedOrderDataMap.filteredProducts.length > 0 && (
        <SICardComponent
          Button={Button}
          isOpenModal={isOpenModal}
          orderDataMap={supplementedOrderDataMap}
          expanded={expandedMap.currentId === id}
          isNeitherCardExpandedYet={isNeitherCardExpandedYet}
          handleAccordionChange={handleAccordionChange}
          handleModalShow={handleModalShow}
          changeOrderGroupStatus={changeOrderGroupStatus}
        />
      )}
    </>
  );
};

export default SICardContainer;
